import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { map, switchMap } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { UserStore } from '../stores/user.store'
import { isFeatureAllowed } from '../config/feature-permission.config'

/** 商談録音機能のフィーチャーフラグガード */
export const meetingRecordingGuard: CanActivateFn = () => {
  const router = inject(Router)
  const authService = inject(AuthService)
  const userStore = inject(UserStore)

  return authService.user$.pipe(
    switchMap(() =>
      userStore.getOneSelf({ useCache: true }).pipe(
        map((user) => {
          if (isFeatureAllowed('MEETING_RECORDING', user.enabledFeatures)) {
            return true
          }
          router.navigate(['/home'])
          return false
        }),
      ),
    ),
  )
}
